// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"66":"d1f66e0115cf2e09","124":"18d144cf36258ff2","608":"dceff0265c8b3321","765":"6ea9a47eaab3f809","784":"31f2fd26fc473de8"}[chunkId] + ".js";
};